import { useEffect } from 'react'

// this is a workaround to explicit dependency linter errors
export default function useMountEffect(func) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(func, [])
}
